import { useMutation, useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    _api_delete_document,
    _api_get_document_data,
    downloadFile,
} from "../api";
import { useToastGlobal } from "../../../stores/useToastGlobal";
import { search } from "@microsoft/teams-js";

const useLogicDetailDocument = () => {
    // * HOOKS
    // * HOOKS
    // * HOOKS
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // * STATES
    // * STATES
    // * STATES
    const alert = useToastGlobal();

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { data, isLoading, isFetching } = useQuery(
        ["get_document", searchParams.get("fid")],
        (data) => {
            const fid = data.queryKey[1];
            return _api_get_document_data({
                fid,
                document_type: searchParams.get("dt"),
            });
        },
        {
            refetchOnWindowFocus: false,
        }
    );

    const { isLoading: isDownloading, mutate: handleDownload } = useMutation(
        () => {
            return downloadFile({ document_id: searchParams.get("fid") });
        }
    );

    const { isLoading: isDeleting, mutate: handleDelete } = useMutation(
        () => {
            return _api_delete_document({
                document_id: searchParams.get("fid"),
            });
        },
        {
            onSuccess: (data) => {
                if (data?.success) {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "success",
                        content: "Suppression effectuée",
                    });
                    navigate(-1);
                } else {
                    return alert.setShow({
                        ...alert,
                        visible: true,
                        level: "danger",
                        content: "Erreur lors de la suppression",
                    });
                }
            },
        }
    );

    // * RETURN
    // * RETURN
    // * RETURN
    return {
        query: {
            data,
            isLoading,
            isFetching,
        },
        download: {
            isLoading: isDownloading,
            handleDownload: handleDownload,
        },
        delete_document: {
            isLoading: isDeleting,
            handleDelete: handleDelete,
        },
        navigation: {
            goBack: () => {
                navigate(-1);
            },
        },
    };
};

export default useLogicDetailDocument;
